import React from 'react';
import PillBase from './PillBase';
import TPillBase from './types/TPillBase';

const Pill = ({ children, ...rest }: Omit<TPillBase, 'icon'>) => <PillBase {...rest}>{children}</PillBase>;

export default Pill;
